// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1PcpP","footer":"ModalInfo_footer__gK00V"};